import { WARMUPS_SONG_ID } from '../../../../services/songNotesModel';

/**
 * Which songs are PILLS in a lesson (2026-10-02, Anthony: "move the warm up
 * and song pills to a dropdown. Some of the students reps will grow quite a
 * bit"). Until then every song in the student's repertoire was a pill, so a
 * long repertoire wrapped the tab row into several lines.
 *
 * A song is a pill when this lesson is using it:
 *   - Warm-ups, always;
 *   - the song on screen;
 *   - a song opened from the Songs picker this lesson (session scratch);
 *   - a song with a note written in THIS lesson (originLessonId), so the
 *     pills come back after a reload or on another device;
 * minus a song the teacher tucked away with its ×, unless it is on screen.
 * Everything else is one tap away in the Songs picker.
 */
export const todaySongIds = ({ songs = [], lessonId = null, currentSongId = null, opened = [], closed = [] }) => {
	const out = new Set([WARMUPS_SONG_ID]);
	const shut = new Set(closed);
	songs.forEach((s) => {
		if (!s || s.id === WARMUPS_SONG_ID) return;
		const notedHere = lessonId && (s.notes || []).some((n) => n && n.originLessonId === lessonId);
		if ((opened.includes(s.id) || notedHere) && !shut.has(s.id)) out.add(s.id);
	});
	if (currentSongId) out.add(currentSongId);
	return out;
};

/** The picker's list: every repertoire song, A-Z, filtered by name. */
export const pickerSongs = (songs = [], filter = '') => {
	const q = String(filter || '').trim().toLowerCase();
	return songs
		.filter((s) => s && s.id !== WARMUPS_SONG_ID)
		.filter((s) => !q || String(s.name || '').toLowerCase().includes(q))
		.sort((a, b) => String(a.name || '').localeCompare(String(b.name || ''), undefined, { sensitivity: 'base' }));
};

export const openCount = (song) => (song.notes || []).filter((n) => n.status !== 'landed').length;
